module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/customer/customer-04-b08b5aa645c5dbdb188a49d9f92ded09.jpg";